import ReactDOM from 'react-dom';
import React from 'react';
import Faq from './Faq';
import './frontend.css';

function renderFaqSectionComponents() {
    const sections = document.querySelectorAll('section[id^="mm_faq_block_"]');
    sections.forEach(section => {
        const config = section.getAttribute('data-config');
        if (config) {
            const parsedConfig = JSON.parse(config);
            const container = section.querySelector('.react-faq-block');
            if (container) {
                ReactDOM.render(
                <Faq
                    config={parsedConfig}
                    category_code={parsedConfig.category_code}
                    numOfFaqs={parsedConfig.numOfFaqs}
                    columnLayout={parsedConfig.columnLayout}
                    type={parsedConfig.type}
                    tags={parsedConfig.tags}
                />,
                container
                );
            } else {
                console.error('FAQ Container element not found');
            }
        } else {
            console.error('FAQ Configuration not found');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    renderFaqSectionComponents();
});